import React, { useRef, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import EditProfileForm from "./EditProfileForm";
import axiosInstant from "../../../api";
import { createUserProTeam } from "../../../api/endpoints";
import {
  ProFormTabs,
  defaultTabsPercentage,
  getProfilePercentage,
} from "./tabs";
import { TabsPanel } from "./tabsPanel";
import ExpertFormHeader from "./ExpertFormHeader";

export default function CreateProfile({ isDialog = false, onComplete }) {
  const prevValues = useRef("");
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const [selectedTab, updateTab] = useState(ProFormTabs.Basics);
  const [percentage, setPercentage] = useState(defaultTabsPercentage);

  const handleSubmit = (values, actions) => {
    const createUser = async (v) => {
      const response = await axiosInstant.post(createUserProTeam(), v);
      const { data } = response;

      actions.setSubmitting(false);
      toast.success("User saved");
      if (onComplete) onComplete(data);
      else navigate(`/experts/${data.userid}/${data.slug || "-"}/edit`);
      return data;
    };
    try {
      createUser(values);
    } catch (e) {
      console.error(e);
      toast.error("Could not save :(", { duration: 3000 });
      actions.setSubmitting(false);
    }
  };

  const updatePercentage = (profile) => {
    const res = getProfilePercentage(profile);
    const newValues = JSON.stringify(res);
    if (prevValues.current !== newValues) {
      prevValues.current = newValues;
      setPercentage({ ...res });
    }
  };

  const tabProps = { selectedTab, updateTab };
  return (
    <Box marginTop={isDialog ? 0 : 4}>
      <div className="container mx-auto">
        {!isDialog && <ExpertFormHeader create />}

        <Box
          display="flex"
          gap={2}
          mt={isDialog ? 0 : 5}
          flexDirection={isSmallScreen ? "column" : "row"}
        >
          <TabsPanel
            {...tabProps}
            inline={isSmallScreen}
            percentage={{ ...percentage }}
          />
          <EditProfileForm
            create
            {...tabProps}
            pro={{}}
            onProUpdate={updatePercentage}
            handleSubmit={handleSubmit}
            hideMarginTop={isDialog}
          />
        </Box>
      </div>
    </Box>
  );
}

CreateProfile.defaultProps = {
  onComplete: null,
};
